//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 14.07.2016.
 */
(function () {
    'use strict';

    angular.module('container.core')
        .constant('Event',  {
            'USER_LOGGED_IN': 'container:userLoggedIn',
            'USER_LOGGED_OUT': 'container:userLoggedOut',
            'USER_UNKNOWN': 'container:userUnknown',
            'OC_STAT_SERVICE_STARTED': 'operatorclientStatusService:started',
            'OC_STAT_SERVICE_RESTART': 'operatorClientStatService:restart',
            'OC_RESTARTED': 'operatorClient:restarted',
            'OC_ERROR': 'operatorClient:error'
        });
}());
